import React from 'react';
import Icon from 'components/DesignSystem/Icon';

import DatePicker from 'components/DatePicker';

import './index.scss';

export default function InvoiceDatePicker({ startDate, endDate, onDateChange }: {
  startDate: Date | null,
  endDate: Date | null,
  onDateChange: (dates: [Date | null, Date | null]) => void,
}) {
  const iconClassName = `me-2 calendar-icon${startDate && endDate ? ' calendar-active' : ''}`;

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className="d-flex flex-row align-items-center flex-shrink-1">
      <div className={`d-flex justify-content-center align-items-center p-0 ${iconClassName}`}>
        <Icon iconType="calendar" />
      </div>
      <DatePicker
        className="invoice-datepicker"
        placeholderText="Período"
        selectsRange
        startDate={startDate || undefined}
        endDate={endDate || undefined}
        onChange={onDateChange}
      />
    </label>
  );
}
